import { MDBIcon, MDBInput, MDBRow } from 'mdbreact'
import React from 'react'

const SearchBar = ({sortAscending, setSortAscending, toggleAlphabetic, searchTerm, handleChange, setSearchTerm, orderListAlphabetical, orderListByType}) => {
  return (
    <MDBRow className='search-bar w-100 d-flex justify-content-center align-items-center mb-3 flex-md-nowrap z-depth-1'>
        <div className='d-flex col-sm-12 col-md-5 justify-content-around align-items-center flex-row p-1 p-sm-2 border-radius-search-bar mb-2'>
            <div className='d-flex text-center deep-orange-text flex-column justify-content-center align-items-center'>
                <MDBIcon className="search-by-btn text-center" fas icon={`${toggleAlphabetic ? 'sort-alpha-down-alt' : 'sort-alpha-up'}`} size="2x" onClick={() => orderListAlphabetical(!toggleAlphabetic)}/>
                <h5 className='d-none d-md-inline-block'>Alphabetical</h5>
            </div>
            <div className='d-flex text-center deep-orange-text flex-column justify-content-center align-items-center'>
                <MDBIcon className="search-by-btn text-center" far icon="calendar-alt" size="2x" onClick={() => {
                    orderListByType('year');
                    setSortAscending(!sortAscending);
                }} />
                <h5 className='mt-2 d-none d-md-inline-block'>By year</h5>
            </div>
            <div className='d-flex text-center deep-orange-text flex-column justify-content-center align-items-center'>
                <MDBIcon className="search-by-btn text-center" fab icon="imdb" size="2x" onClick={() => {
                    orderListByType('IMDbRating');
                    setSortAscending(!sortAscending);
                } } />
                <h5 className='mt-2 d-none d-md-inline-block'>By IMDB rating</h5>
            </div>
            <div className='d-flex text-center deep-orange-text flex-column justify-content-center align-items-center'>
                <MDBIcon className="search-by-btn text-center" far icon="clock" size="2x" onClick={() => {
                    orderListByType('runtime');
                    setSortAscending(!sortAscending);
                }} />
                <h5 className='mt-2 d-none d-md-inline-block'>By runtime</h5>
            </div>
            <div className='d-flex text-center deep-orange-text flex-column justify-content-center align-items-center'>
                <MDBIcon className="search-by-btn text-center" far icon="bell" size="2x" onClick={() => {
                    orderListByType('id');
                    setSortAscending(!sortAscending);
                }} />
                <h5 className='mt-2 d-none d-md-inline-block'>By date added</h5>
            </div>
        </div>
        <div className='d-flex col-sm-12 col-md-7 justify-content-between align-items-center flex-row border-radius-search-bar'>
            <div className="col-sm-11">
                <MDBInput 
                    id="searchInput"
                    labelId="searchLabel"
                    label="search movies, directors or actors" 
                    icon="search" 
                    value={searchTerm.toLowerCase()} 
                    onChange={handleChange}
                />
            </div>
            <div className="col-sm-1 text-center">
                {/* o icon do limpar texto só aparece se o value do searchTerm tiver texto para ser apagado*/
                searchTerm !== '' 
                ? <MDBIcon className=" orange-text" icon="times" size="2x" style={{cursor: "pointer"}} onClick={() => setSearchTerm('')}/> 
                : null
                }
            </div>
        </div>
    </MDBRow>
  )
}

export default SearchBar
